/**
 * Shared message contract for iframe AI context bridge communication.
 * These types define the postMessage protocol between parent frame and iframes.
 */

export type AiContextRegisterMessage = {
  type: 'AI_CONTEXT_REGISTER';
  path: string;
  frameId: string;
};

export type AiContextUnregisterMessage = {
  type: 'AI_CONTEXT_UNREGISTER';
  path: string;
};

export type AiContextGetMessage = {
  type: 'AI_CONTEXT_GET';
  path: string;
  requestId: string;
};

export type AiContextResultMessage = {
  type: 'AI_CONTEXT_RESULT';
  path: string;
  context: unknown;
  requestId: string;
};

export type AiContextNotifyMessage = {
  type: 'AI_CONTEXT_NOTIFY';
  path: string;
};

export type AiContextMessage =
  | AiContextRegisterMessage
  | AiContextUnregisterMessage
  | AiContextGetMessage
  | AiContextResultMessage
  | AiContextNotifyMessage;

/**
 * Type guard to check if a message is an AI context message
 */
export function isAiContextMessage(data: unknown): data is AiContextMessage {
  return (
    typeof data === 'object' &&
    data !== null &&
    'type' in data &&
    typeof data.type === 'string' &&
    data.type.startsWith('AI_CONTEXT_')
  );
}
